export const stripDelimiters = (jsCodeWithDilimiter: string) =>
  jsCodeWithDilimiter.substring(2, jsCodeWithDilimiter.length - 2);
